import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Unstable_Grid2'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded'

import StatisticCard from '@/components/ui/cards/StatisticCard'

import { BulkOrderStatus } from '@/core/models/bulk-order.model'
import { OrderStatus } from '@/core/models/order.model'

type MeetingLinksStatisticProps = {
  meetingLinksCount: number
  pendingBulkOrderCount?: number
  pendingOrderCount: number
  ordersCount: number
}

function NavButton({ href, tooltip }: { href: string; tooltip: string }) {
  return (
    <Tooltip title={tooltip} placement="top">
      <IconButton component={Link} to={href} size="small" sx={{ position: 'absolute', right: 16.5, bottom: 16.5 }}>
        <ArrowRightAltRoundedIcon htmlColor="white" fontSize="large" />
      </IconButton>
    </Tooltip>
  )
}

export function MeetingLinksStatistic(props: MeetingLinksStatisticProps) {
  const { meetingLinksCount, pendingBulkOrderCount, pendingOrderCount, ordersCount } = props
  const { t } = useTranslation()

  return (
    <Grid container minHeight="100%" spacing={2}>
      <Grid xs={6} sm={3} md={6}>
        <Box height="100%" position="relative">
          <StatisticCard
            disableIcon
            sx={{ bgcolor: '#38bdf8', color: 'white' }}
            title={t('page.home.statistic.totalMeetingLink.title')}
            value={meetingLinksCount}
          />
          <NavButton href="/meeting-links" tooltip={t('page.home.statistic.totalMeetingLink.navButton.tooltip')} />
        </Box>
      </Grid>
      {typeof pendingBulkOrderCount === 'number' && (
        <Grid xs={6} sm={3} md={6}>
          <Box height="100%" position="relative">
            <StatisticCard
              disableIcon
              sx={{ bgcolor: '#34d399', color: 'white' }}
              title={t('page.home.statistic.pendingBulkOrderCount.title')}
              value={pendingBulkOrderCount}
            />
            <NavButton
              href={`/meeting-links/bulk-orders?status=${BulkOrderStatus.Pending}`}
              tooltip={t('page.home.statistic.pendingBulkOrderCount.navButton.tooltip')}
            />
          </Box>
        </Grid>
      )}
      <Grid xs={6} sm={3} md={6}>
        <Box height="100%" position="relative">
          <StatisticCard disableIcon sx={{ bgcolor: '#818cf8', color: 'white' }} title={t('page.home.statistic.totalOrder.title')} value={ordersCount} />
          <NavButton href="/meeting-links/orders" tooltip={t('page.home.statistic.totalOrder.navButton.tooltip')} />
        </Box>
      </Grid>
      <Grid xs={6} sm={3} md={6}>
        <Box height="100%" position="relative">
          <StatisticCard
            disableIcon
            sx={{ bgcolor: '#1e3a8a', color: 'white' }}
            title={t('page.home.statistic.pendingOrderCount.title')}
            value={pendingOrderCount}
          />
          <NavButton href={`/meeting-links/orders?status=${OrderStatus.Pending}`} tooltip={t('page.home.statistic.pendingOrderCount.navButton.tooltip')} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default MeetingLinksStatistic
